import { render } from "./Spinner.vue?vue&type=template&id=abb899de"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=abb899de&lang=css"

import exportComponent from "/home/parallels/Web/Repos/mentee-mentor/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__